import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import company from '../views/company.vue'
import search from '../views/search.vue'
import contact from '../views/contactWithUs.vue'
import news from '../views/news.vue'
import GroupNews from '../views/News/GroupNews.vue'
import newsDetail from '../views/newsDetail.vue'

// 报错解决
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: index,
        meta: {
            title: '首页'
        }
    },
    {
        path: '/company',
        name: 'company',
        component: company,
        meta: {
            title: '企业文化'
        }
    },
    {
        path: '/search',
        name: 'search',
        component: search,
        meta: {
            title: '物流查询'
        }
    },
    {
        path: '/news',
        component: news,
        children: [
            {
                path: '',
                component: GroupNews,
                name: 'GroupNews',
                meta: {
                    title: '最新新闻'
                }
            }
        ],
        meta: {
            title: '最新新闻'
        }
    },
    {
        path: '/newsDetail',
        name: 'newsDetail',
        component: newsDetail,
        meta: {
            title: '新闻详情'
        }
    },
    {
        path: '/contact',
        name: 'contact',
        component: contact,
        meta: {
            title: '联系我们'
        }
    }
]
// title

const router = new VueRouter({
    routes,
    // 跳转页面后 回到顶部
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router

// title
const defaultTitle = '默认 title'
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : defaultTitle
    next()
})
